// eslint-disable-next-line @typescript-eslint/ban-types
export default function once(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        if (fn) {
            result = fn.apply(this, args);
            // eslint-disable-next-line no-param-reassign
            fn = null;
        }
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
}

//# sourceMappingURL=once.js.map